import {frontend} from 'pageflow-scrolled/frontend';

import {NoenFooter} from './NoenFooter';
import {BvzFooter} from './BvzFooter';

frontend.widgetTypes.register('noenFooter', {
  component: NoenFooter
});

frontend.widgetTypes.register('bvzFooter', {
  component: BvzFooter
});
